import { render } from "./VideosDialog.vue?vue&type=template&id=e774884a&class=z-index-3"
import script from "./VideosDialog.vue?vue&type=script&lang=js"
export * from "./VideosDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__